import {create} from "@/api/rest";

const avatar = {
  saveAvatar: async (data) => await create('/avatar/save', data),
};

export default avatar;